import { clsx } from "clsx";
import { isEqual } from "lodash";
import React, { PropsWithChildren } from "react";

import { ProcessTreeItem as ProcessTreeItemType } from "../../../../@types";
import useBehaviorContext from "./hooks/useBehaviorContext";
import { RenderWhen } from "../../../../../../components";

type Props = {
  process: ProcessTreeItemType;
  showAdditionalInfo?: boolean;
};

const ProcessTreeItem: React.FC<PropsWithChildren<Props>> = ({
  children,
  process,
  showAdditionalInfo = true
}) => {
  const { active, setActive } = useBehaviorContext();

  const { name, parameters, process_id } = process;
  const isActive = isEqual(process, active);

  const handleClick = () => {
    setActive(process);
  };

  return (
    <li className="process-tree__item">
      <div className="process-tree__item-container">
        <span
          data-testid={`${name}-${process_id}-tree-item`}
          className={clsx("process-tree__item-link", isActive && "active")}
          onClick={handleClick}
        >
          {name}
        </span>{" "}
        <RenderWhen condition={showAdditionalInfo}>
          (ID: {process_id}, parameters: {parameters})
        </RenderWhen>
      </div>
      {children}
    </li>
  );
};

export default ProcessTreeItem;
